import Logo from "@/components/Logo";
import { FooterNewsletter } from "@/components/footer/FooterNewsletter";
import { FooterLinks } from "@/components/footer/FooterLinks";

export default function Footer() {
  return (
    <footer className="bg-zinc-950 text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 pb-14 border-b border-white/10">
          <div className="lg:col-span-7">
            <h3 className="font-display font-bold text-2xl mb-2">Join the Movement</h3>
            <p className="text-zinc-400 text-sm max-w-md">Get updates on new features, advocacy wins, and how BBAP is turning documentation into accountability.</p>
          </div>
          <FooterNewsletter />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Logo showText={false} size="h-20" inverse />
            <p className="text-zinc-400 text-sm mt-4 leading-relaxed">
              Bias is behavior. Behavior can be documented. Documented behavior becomes data.
              Data becomes accountability. Accountability becomes change.
            </p>
          </div>
          <FooterLinks />
        </div>
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-center text-xs font-bold uppercase tracking-[0.15em] text-zinc-500">
            Tell the Story. Document the Behavior. Validate the Pattern. Organize the Response. Push the Change.
          </p>
          <p className="text-center text-xs text-zinc-600 mt-4">© {new Date().getFullYear()} Bias Behavior Analysis Project (BBAP). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
